import React from 'react';
import { LuCircleAlert, LuFileDown } from 'react-icons/lu';
import useExportStore from '../../store/exportStore';
import Button from './Button';

const buttonSizes = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
};

/**
 * Exports a chat message or report as a PDF through useExportStore.generatePDF.
 * After a failure the button shows the error and a click retries.
 */
const PDFGenerateButton = ({ params, size = 'small' }) => {
  const { loading, error, generatePDF } = useExportStore();

  const handleClick = () => {
    if (!loading) {
      generatePDF(params);
    }
  };

  return (
    <Button
      variant={error ? 'danger' : 'secondary'}
      size={buttonSizes[size] || 'sm'}
      onClick={handleClick}
      loading={loading}
      leftIcon={error ? <LuCircleAlert className="size-4" /> : <LuFileDown className="size-4" />}
      title={error ? `Error: ${error}. Click to retry.` : 'Export as PDF'}
    >
      {loading ? 'Preparing PDF…' : error || 'Export PDF'}
    </Button>
  );
};

export default PDFGenerateButton;
